import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Privacy() {
  const sections = [{
    title: "Data Collection",
    body: "We collect only the essential operational data required to architect your backend infrastructure. This includes system configurations, workflow requirements, and integration parameters necessary for modernizing your trade business. We do not track personal browsing habits or unrelated metadata."
  }, {
    title: "Operational Integrity",
    body: "Your business data is treated as a proprietary asset. We implement strict access controls and encryption standards to ensure that your CRM, FSM, and bookkeeping integrations remain secure. We do not sell, trade, or lease your operational data to third-party marketing entities."
  }, {
    title: "Mobile Information and SMS Opt-In Consent",
    body: "No mobile information or messaging originator opt-in data will be shared with or sold to any third parties or affiliates for marketing or promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will strictly remain isolated and will not be shared."
  }, {
    title: "System Governance",
    body: "Our commitment to your privacy outlives our active engagement. We provide clear documentation on how your systems are configured and how data flows between your integrated tools. By the time we conclude our project, you maintain full ownership and visibility over your digital infrastructure."
  }];
  return <section data-section-id="10786" id="privacy-policy" className="bg-background py-28 md:py-40 text-foreground">
      <div className="mx-auto w-full max-w-[1440px] px-5 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12">
          <div className="md:col-span-8 md:col-start-3">
            {}
            <p className="text-center text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground" style={{
            letterSpacing: "0.12em"
          }}>
              Legal
            </p>

            {}
            <h2 className="font-default mt-8 text-left font-medium text-foreground" style={{
            fontSize: "clamp(2.25rem, 4.5vw, 4rem)",
            lineHeight: 1.0,
            letterSpacing: "-0.02em"
          }}>
              Privacy{" "}
              <span className="italic underline decoration-primary" style={{
              textDecorationThickness: "4px",
              textUnderlineOffset: "6px"
            }}>
                Policy
              </span>
              .
            </h2>

            {}
            <div className="mt-12 h-px w-full bg-border" />

            {}
            <div>
              {sections.map((item, i) => <div data-index={i} key={item.title} className={i === 0 ? "pt-12" : ""}>
                  <h4 className="font-default font-medium text-foreground" style={{
                fontSize: "clamp(1.125rem, 1.4vw, 1.25rem)",
                lineHeight: 1.25,
                letterSpacing: "-0.005em"
              }}>
                    {item.title}
                  </h4>
                  <p className="mt-5 text-muted-foreground" style={{
                fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)",
                lineHeight: 1.6
              }}>
                    {item.body}
                  </p>
                  {i < sections.length - 1 && <div className="my-12 h-px w-full bg-border" />}
                </div>)}
            </div>

            {}
            <div className="mt-12 h-px w-full bg-border" />

            {}
            <div className="mt-12">
              <Link to="/TermsPage" className="font-default inline-flex items-center gap-2 font-medium text-foreground decoration-primary hover:text-primary" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)",
              textDecorationLine: "underline",
              textDecorationThickness: "1px",
              textUnderlineOffset: "4px"
            }}>
                Review our Terms and Conditions
                <ArrowRight className="h-5 w-5" strokeWidth={1.5} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}